<div class="d-flex justify-content-between align-items-center my-2">
  <div class="d-flex align-items-center">
    <img src="assets/images/random_assets/warning.png" alt="warning icon" />
    <div class="card-sub-heading ml-3 bold">Unsave Change</div>
  </div>
</div>

<div>
  <div class="ml-3 my-3">
    <div class="card-sub-heading">WARNING!</div>
    <div class="mt-2 bold" style="color: #e3432a">
      You have unsaved changes. Press Cancel to go back and save these changes,
      or OK to lose these changes.
    </div>
  </div>
</div>
<div class="align-items-center mt-4 justify-content-center">
  <button class="custom-btn w-100" (click)="this.dialogRef.close(true)">
    OK
  </button>
  <button class="custom-btn mt-3 w-100" (click)="this.dialogRef.close(false)">
    Cancel
  </button>
</div>
